import { TopLevelBlock, Table, BLOCKS } from '@contentful/rich-text-types'

export function isTable(node: TopLevelBlock): node is Table {
  return node?.nodeType === BLOCKS.TABLE
}
